import React from 'react';

import { MINIMAL_FOOTER } from '../../constants';

import HeaderNavComponent from '../header/HeaderNavComponent';
import FooterComponent from '../footer/FooterComponent';
import MinimalFooterComponent from '../footer/minimal/MinimalFooterComponent';
import { BreadcrumbComponent } from '../breadcrumb/BreadcrumbComponent';

import { Template } from './TemplateStyle';

export const CategoryDirectoryTemplate = props => {
    return (
        <Template className="flex-container-v">
            <HeaderNavComponent />
            {React.cloneElement(props.children, {
                Breadcrumb: BreadcrumbComponent
            })}
            {MINIMAL_FOOTER ? <MinimalFooterComponent /> : <FooterComponent />}
        </Template>
    );
};



// WEBPACK FOOTER //
// ./src/components/template/CategoryDirectoryTemplate.js